import React, { useEffect, useRef } from "react";

const AdSocialBar = () => {
    const adRef = useRef(null);

    useEffect(() => {
        if (!adRef.current) return;
        const adNode = adRef.current;
        const script = document.createElement("script");
        script.setAttribute("data-cfasync", "false");
        script.src = "https://brijmohan.org/14/3dbf90a43a3c05e5eba2949adce33c8d";
        script.async = true;
        adNode.appendChild(script);

        return () => {
            adNode.innerHTML = "";
        };
    }, []);

    return <div ref={ adRef }/>;
};

export default AdSocialBar;
